import { useState, useEffect } from "react";
import { environment } from "../../environment";

export function useAppVersion(): string | undefined {
  const [version, setVersion] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    environment()
      .then((env) => {
        if (!cancelled) setVersion(env.APP_VERSION);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return version;
}
